﻿import { onEvent } from "./_dom";

function init() {
	const profiler = document.getElementById("td-profilerend");
	if (!profiler) return;
	onEvent(profiler, ".v3-profiler-request__content,.v3-profiler__operation.ui-icon-expanded,.v3-profiler__operation.ui-icon-collapsed", "click", (_, item) => {
		item.classList.toggle("ui-icon-expanded");
		item.classList.toggle("ui-icon-collapsed");
	});
}

export { init };